import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, isAuthenticated, redirect, isClientSelected, ...children }) => {
  if(redirect && redirect?.length>0)
  {
    return <Redirect from={children.path} to={redirect+children.location.search}/>
  }
  if(!isAuthenticated) {
    return <Redirect to="/login" />
  }

  if(!isClientSelected) {
    return <Redirect to="/client-chooser" />
  }

  return <Route {...children} render={props => <Component {...props} {...children} />} />
};

export default PrivateRoute;
